import DeleteAction from 'components/DeleteAction';
import React, { useEffect, useState } from 'react';
import { fetchPaymentMethodsForUser, removePaymentMethodForUser } from 'services';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';
import PaymentIcon from 'react-payment-icons';
import _ from 'lodash';
import { Loading } from 'components/loading/Loading';

const SavedPaymentMethods = props => {
  const [paymentMethods, setPaymentMethods] = useState<Record<string, any>>([]);
  const [loadingID, setLoadingID] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const {
    user,
    disabled,
    selectedPaymentId,
    setPaymentId,
    savedMethods,
    reload,
  } = props;

  const fetchPaymentMethods = async () => {
    if (!user?.objectId) return;
    setLoading(true);
    try {
      const response = await fetchPaymentMethodsForUser(user.objectId);
      setPaymentMethods(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (savedMethods?.length) {
      setPaymentMethods(savedMethods);
    } else {
      fetchPaymentMethods();
    }
  }, [savedMethods, user?.objectId, reload]);

  const deletePaymentMethod = async (id: string) => {
    setLoadingID(id);
    try {
      await removePaymentMethodForUser(user.objectId, id);
      await fetchPaymentMethods();
      showSuccess('Successfully Deleted Payment Method');
    } catch (e) {
      showError(e);
    } finally {
      setLoadingID('');
    }
  };

  const renderSavedPaymentMethods = () => paymentMethods.map(paymentMethod => {
    const
      id = _.get(paymentMethod, 'id', ''),
      livemode = _.get(paymentMethod, 'livemode', ''),
      stripePaymentMethodId = _.get(paymentMethod, 'stripePaymentMethodId', ''),
      brand = _.get(paymentMethod, 'card.brand', ''),
      // eslint-disable-next-line @typescript-eslint/camelcase
      exp_month = _.get(paymentMethod, 'card.exp_month', ''),
      // eslint-disable-next-line @typescript-eslint/camelcase
      exp_year = _.get(paymentMethod, 'card.exp_year', ''),
      last4 = _.get(paymentMethod, 'card.last4', '')
      ;

    return (
      <div key={id} className={styles['single-payment-method']}>
        {!savedMethods ? (
          <div className={styles['payment-method-radio']}>
            <input
              type={'radio'}
              name={'payment-method'}
              disabled={disabled}
              checked={selectedPaymentId === paymentMethod.id}
              onChange={() => setPaymentId(paymentMethod.id)}
            />
          </div>
        ) : null}
        <div className={styles['payment-method-details']}>
          <div className={'d-flex'}>
            <div className={styles['line1']}>{`**** **** **** ${last4}`}</div>
            <PaymentIcon
              id={brand.toLowerCase()}
              className="payment-icon"
            />
          </div>
          <div className={styles['line2']}>
            <div>{`Expires on:`}</div>
            {/* eslint-disable-next-line @typescript-eslint/camelcase */}
            <div>{`${exp_month}/${exp_year}`}</div>
          </div>
          {livemode && (
            <div className={styles['livemode']}>
              <div>Live Mode:</div>
              <div>{livemode.toString()}</div>
            </div>
          )}
          {stripePaymentMethodId ? (
            <div className={styles['stripe-id']}>
              <div>Stripe Payment ID:</div>
              <div>{stripePaymentMethodId}</div>
            </div>
          ) : null}
        </div>
        <div className={styles['payment-method-action']}>
          {(loadingID === paymentMethod.id) ?
            <Loading type="mini" />
            : <DeleteAction
              loading={false}
              onClick={() => deletePaymentMethod(paymentMethod.id)}
            />
          }
        </div>
      </div>
    );
  });

  const getPaymentMethods = () => {
    if (paymentMethods.length) {
      return renderSavedPaymentMethods();
    } else {
      return <div className={styles['empty-payment-method']}>No Payment Method Added</div>;
    }
  };

  return (
    <div className={styles['payment-methods']}>
      {loading ? <Loading type='mini' /> : getPaymentMethods()}
    </div>
  );
};

export default SavedPaymentMethods;